import { Column, Expaned, Row } from '@/components/layout/layout'
import { usePopoverVisible } from '@/components/popover-confirm/usePopoverVisible'
import SgUpload from '@/components/upload/upload'
import useBemClass from '@/utils/hooks/useBEMClass'
import { layerManage, showLayer } from '@/utils/layer'
import { ChooseMaterialDialog } from '@/views/main/modules/goods-manage/components/material-library/choose-material-dialog'
import { Popover, Spin } from 'antd'
import React, { useState } from 'react'
import './media-edit.scss'

interface MediaPopoverProps {
    type: string
    maxCount?: number
    onSuccess: (res: string[]) => void
    expaned?: boolean
}

const MediaPopover: React.FC<MediaPopoverProps> = props => {
    const popoverAction = usePopoverVisible()
    const cls = useBemClass('media-edit')
    const [loading, setLoaidng] = useState<boolean>(false)

    return (
        <Popover
            {...popoverAction.options}
            placement="top"
            trigger="click"
            content={() => (
                <Column data-padding-h-16 data-padding-v-24>
                    <div data-color-000 data-font-size-14>
                        图片/视频上传规则
                    </div>
                    <div data-color-999 data-font-size-12 data-margin-top-4>
                        1.视频大小不超过100MB，建议时长在5分钟内
                    </div>
                    <div data-color-999 data-font-size-12>
                        2.支持的视频类型包括：MP4
                    </div>
                    <div data-color-999 data-font-size-12>
                        3.图片大小不能超过10MB
                    </div>
                    <Row data-margin-top-12 data-width-100p data-justify-content-flex-end>
                        <div
                            className={cls('popover-item-meta')}
                            onClick={() => {
                                popoverAction.hidden()
                                showLayer(
                                    <ChooseMaterialDialog
                                        maxCount={props.maxCount}
                                        type={props.type === 'iconshipin' ? 'video' : 'image'}
                                        multipleChoose={props.type === 'iconxiaotu'}
                                        onSelected={data => {
                                            props.onSuccess([data.url])
                                            layerManage.pop()
                                        }}
                                        onChoose={data => {
                                            props.onSuccess(data.map(d => d.url))
                                            layerManage.pop()
                                        }}
                                    />,
                                )
                            }}
                        >
                            素材库
                        </div>
                        <SgUpload
                            multiple={props.type === 'iconxiaotu'}
                            maxCount={props.maxCount}
                            onLoad={() => {
                                setLoaidng(true)
                            }}
                            onSuccess={(res, data, list) => {
                                setLoaidng(false)
                                props.onSuccess(list)
                            }}
                        >
                            <div
                                className={cls('popover-item-upload')}
                                onClick={() => {
                                    popoverAction.hidden()
                                }}
                            >
                                本地上传
                            </div>
                        </SgUpload>
                    </Row>
                </Column>
            )}
        >
            {props.expaned ? (
                <Expaned>
                    <Spin spinning={loading}>{props.children}</Spin>
                </Expaned>
            ) : (
                props.children
            )}
        </Popover>
    )
}

export default MediaPopover
